/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useQuery } from 'react-query';
import { coreService } from 'network-utils';

export const getOtherMemebersCompleted = 'other-members-completed-data';
export const getOtherMembersTaken = 'other-members-taken-data';
export const getRecentlyAdded = 'recently-added-data';
export const getHomePageBanners = 'get-home-page-banners';
export const getMyCompletedCourses = 'my-completed-courses-data';
export const getMyCompletedContent = 'my-completed-content-data';
export const getAssignedContent = 'assigned-content-data';
export const getHomePageUsersLeaderboard = 'core-homepage-users-leaderboard';
export const getHomePageTeamsLeaderboard = 'core-homepage-teams-leaderboard';
export const getHomePageLeanContent = 'core-homepage-lean-content';

export const useOtherMembersCompleted = (token: string) => {
    return useQuery(
        [getOtherMemebersCompleted, token],
        () => coreService.homepageApi.getOtherMemebersCompleted(token),
        {
            enabled: !!token,
            keepPreviousData: true
        }
    );
};

export const useOtherMembersTaken = (token: string) => {
    return useQuery([getOtherMembersTaken, token], () => coreService.homepageApi.getOtherMemebersTaken(token), {
        enabled: !!token,
        keepPreviousData: true
    });
};

export const useRecentlyAdded = (token: string) => {
    return useQuery([getRecentlyAdded, token], () => coreService.homepageApi.getRecentlyAdded(token), {
        enabled: !!token,
        keepPreviousData: true
    });
};

export const useGeyHomepageBanners = (token: string) => {
    return useQuery([getHomePageBanners, token], () => coreService.homepageApi.getHomepageBanners(token), {
        enabled: !!token,
        keepPreviousData: true
    });
};

export const useMyCompletedContent = (token: string) => {
    return useQuery([getMyCompletedContent, token], () => coreService.homepageApi.getMyCompletedContent(token), {
        enabled: !!token,
        keepPreviousData: true
    });
};

export const useMyCompletedCourses = (token: string) => {
    return useQuery([getMyCompletedCourses, token], () => coreService.homepageApi.getMyCompletedCourses(token), {
        enabled: !!token,
        keepPreviousData: true
    });
};

export const useLeanContent = (token: string, isCxUniversity?: boolean) => {
    return useQuery([getHomePageLeanContent, token], () => coreService.homepageApi.getLeanContent(token), {
        enabled: !!token && !!isCxUniversity,
        keepPreviousData: true
    });
};

export const useAssignedContent = (token: string) => {
    return useQuery([getAssignedContent, token], () => coreService.homepageApi.getAssignedContent(token), {
        enabled: !!token,
        keepPreviousData: true
    });
};

export const useGetUsersLeaderboards = (
    token: string,
    filters: { offset?: number; limit?: number; search?: string; teamUuid?: string; enableQuery?: boolean }
) => {
    const { offset, limit, search, teamUuid, enableQuery } = filters;
    return useQuery(
        [getHomePageUsersLeaderboard, { token, offset, limit, search, teamUuid }],
        () => coreService.homepageApi.getUserLeaderboard(token, { offset, limit, search, teamUuid }),
        {
            keepPreviousData: true,
            enabled: Boolean(token) && enableQuery
        }
    );
};

export const useGetTeamsLeaderboards = (
    token: string,
    filters: { offset?: number; limit?: number; search?: string; enableQuery?: boolean }
) => {
    const { offset, limit, search, enableQuery } = filters;
    return useQuery(
        [getHomePageTeamsLeaderboard, { token, offset, limit, search }],
        () => coreService.homepageApi.getTeamsLeaderboard(token, { offset, limit, search }),
        {
            keepPreviousData: true,
            enabled: Boolean(token) && enableQuery
        }
    );
};
